export default __webpack_public_path__ + "static/media/jungle-lodges.7c7dc491.svg";